import React from 'react';
import { BringzzShimmer } from '@bringzz/components';

const PostingCardSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm mb-4 p-4">
      {/* Header */}
      <div className="flex items-center mb-4">
        <BringzzShimmer width="40px" height="40px" rounded={true} className="mr-3" />
        <div className="flex-1">
          <BringzzShimmer height="20px" width="150px" className="mb-2" />
          <BringzzShimmer height="16px" width="100px" />
        </div>
      </div>
      
      {/* Content */}
      <BringzzShimmer height="200px" className="mb-4 rounded" />
      
      {/* Footer */}
      <div className="flex justify-between items-center">
        <BringzzShimmer height="24px" width="80px" />
        <BringzzShimmer height="24px" width="60px" />
      </div>
    </div>
  );
};

export default PostingCardSkeleton; 